module.exports = __webpack_public_path__ + "static/media/mq1@2x.49068aa4.jpg";